import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { fetchData } from "./Utilities";
import Form from "react-bootstrap/Form";
const InComeRlsModal = ({ isOpen, closeModal, onExit, onExited, userId }) => {
  const [mob, setMob] = useState({ value: "", error: null });
  const [coin, setCoin] = useState({ value: 0, error: null });
  const [type, setType] = useState({ value: "", error: null });
  const [desc, setDesc] = useState('');
  const [typeList, setTypeList] = useState([]);
  console.log(type.value,type.error)

  const saveCoins = async () => {
    if (!coin.value) {
      setCoin({
        value: coin.value,
        error: "لطفا مقدار ریالی را وارد نمایید.",
      });
      return;
    }
    if (!mob.value) {
      setMob({ value: mob.value, error: "لطفا شماره موبایل را وارد کنید" });
      return;
    }
    if (!type.value) {
      setType({ value: type.value, error: "لطفا نوع عملیات را انتخاب کنید" });
      return;
    }

    setCoin({ value: coin.value, error: "" });
    setMob({ value: mob.value, error: "" });
    setType({ value: type.value, error: "" });
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("fund", coin.value);
    bodyFormData.append("mob", mob.value);
    bodyFormData.append("type", type.value);
    bodyFormData.append("description", desc);
    fetchData("incomefund", bodyFormData, handleApiResponse);
  };
  const handleApiResponse = (data) => {
    closeModal();
    SweetAlert({
      title: "",
      text: data.msg,
      type: `${data.code === 0 ? "failed" : "success"}`,
    });
    
    setCoin({ value: 0, error: null });
    setMob({ value:0, error: null });
    setType({ value: "type.value", error: null });
    setDesc('')
  };

  useEffect(() => {
    fetchData("fundtype", {}, handleTypeResponse);
  }, []);
  const handleTypeResponse = (data) => {
    const mapOptions = (value) => {
      return value?.map((item) => ({
        value: item.id,
        label: `${item.typename}`,
      }));
    };
    const values = mapOptions(data?.dt);
    setTypeList(values);
  };
  console.log(typeList);
  return (
    <Modal
      show={isOpen}
      onHide={closeModal}
      onExit={onExit}
      onExited={onExited}
      centered
    >
      <Modal.Header>
        <div className="m-auto maxh-20 fw-bold text-secondary ">
          دریافت مبلغ ریالی
        </div>

        <button
          className="btn-close bg-danger text-white"
          onClick={() => closeModal()}
        />
      </Modal.Header>
      <Modal.Body
        className="justify-content-center mx-4
            "
      >
        <>
          <Form.Group className="mb-3 w-75">
            <Form.Label className="fw-bold pb-1"> مبلغ ریالی </Form.Label>
            <Form.Control
              type="number"
              onChange={(e) => setCoin({ value: e.target.value, error: "" })}
            />
            {coin.error && (
              <p className="text-danger text-center">{coin.error}</p>
            )}
          </Form.Group>
          <Form.Group className="mb-3 w-75">
            <Form.Label className="fw-bold pb-1">شماره موبایل کاربر</Form.Label>
            <Form.Control
              type="telephone"
              maxLength={11}
              onChange={(e) => setMob({ value: e.target.value, error: "" })}
            />
            {mob.error && (
              <p className="text-danger text-center">{mob.error}</p>
            )}
          </Form.Group>
          <Form.Group className="mb-3 w-75">
            <Form.Label className="fw-bold pb-1">نوع عملیات</Form.Label>
            <Form.Select onChange={(e) => setType({value: e.target.value, error:""})}>
              <option disabled>نوع عملیات راانتخاب کنید</option>
              {typeList?.map((type) => (
                <option value={type.value}>{type.label}</option>
              ))}
            </Form.Select>
            {type.error && (
              <p className="text-danger text-center">{type.error}</p>
            )}
          </Form.Group>
          <Form.Group className="mb-3 w-75">
            <Form.Label className="fw-bold pb-1">توضیحات</Form.Label>
            <Form.Control
              type="text"
              onChange={(e) => setDesc(e.target.value)}
            />
          </Form.Group>
        </>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="primary" onClick={() => saveCoins()}>
          ذخیره
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InComeRlsModal;
